import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { Chip } from 'primereact/chip';
import { toast } from 'react-toastify';
import axiosInstance from '../../../config/axios.config';
// import './EHFUANOutput.css';

const EHFUANOutputComponent = ({ reportData, serviceInfo, serviceDetails, actualServiceDetails, onDownloadPDF, pdfDownloadUrl, hideCredits, isSharedView }) => {
    // Hide credits if either hideCredits or isSharedView is true
    const shouldHideCredits = hideCredits || isSharedView;

    // Handle Code 1004 (No data found) - CHECK THIS FIRST
    if (reportData?.code === '1004') {
        return (
            <div className="uan-employment-output-container">
                <Card className="text-center p-6">
                    <i className="pi pi-info-circle text-6xl text-blue-500 mb-4"></i>
                    <h3 className="text-900 mb-3">UAN Employment History Report</h3>

                    <div className="bg-blue-50 border-round-lg p-4 mb-4">
                        <h4 className="text-blue-700 m-0 mb-3">
                            <i className="pi pi-search mr-2"></i>
                            No Employment Records Found
                        </h4>
                        <p className="text-blue-600 line-height-3 m-0">
                            The UAN number provided does not have any employment history in the EPFO records.
                            This could happen when:
                        </p>
                    </div>

                    <div className="text-left mb-4">
                        <div className="flex align-items-start mb-2">
                            <i className="pi pi-arrow-right text-blue-500 mt-1 mr-2" style={{fontSize: '12px'}}></i>
                            <span className="text-700">The UAN number entered is incorrect</span>
                        </div>
                        <div className="flex align-items-start mb-2">
                            <i className="pi pi-arrow-right text-blue-500 mt-1 mr-2" style={{fontSize: '12px'}}></i>
                            <span className="text-700">The applicant hasn't started their PF contributions yet</span>
                        </div>
                        <div className="flex align-items-start mb-2">
                            <i className="pi pi-arrow-right text-blue-500 mt-1 mr-2" style={{fontSize: '12px'}}></i>
                            <span className="text-700">The UAN is newly created and not yet activated</span>
                        </div>
                        <div className="flex align-items-start mb-2">
                            <i className="pi pi-arrow-right text-blue-500 mt-1 mr-2" style={{fontSize: '12px'}}></i>
                            <span className="text-700">The applicant may have a different UAN number</span>
                        </div>
                    </div>

                    <div className="bg-orange-50 border-round-lg p-3 mb-4 border-left-3 border-orange-500">
                        <div className="flex align-items-center">
                            <i className="pi pi-exclamation-triangle text-orange-600 mr-2"></i>
                            <span className="text-orange-700 font-medium text-sm">
                                Important: Credits have been used for this verification as the check was completed successfully.
                            </span>
                        </div>
                    </div>

                    <div className="bg-green-50 border-round-lg p-3 border-left-3 border-green-500">
                        <div className="flex align-items-start">
                            <i className="pi pi-lightbulb text-green-600 mr-2 mt-1"></i>
                            <div>
                                <span className="text-green-700 font-medium text-sm block mb-1">
                                    What you can do next:
                                </span>
                                <ul className="m-0 pl-3">
                                    <li className="text-green-700 text-sm">Verify the UAN number with the applicant again</li>
                                    <li className="text-green-700 text-sm">Check other employment documents like salary slips or appointment letter</li>
                                    <li className="text-green-700 text-sm">Try Employment History by Mobile Number instead</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    // Use actualServiceDetails first, then serviceDetails, then serviceInfo for backward compatibility
    const effectiveServiceInfo = actualServiceDetails || serviceDetails || serviceInfo;

    console.log('=== EHFUANOutputComponent PROPS ===');
    console.log('reportData:', reportData);
    console.log('reportData type:', typeof reportData);
    console.log('reportData keys:', reportData ? Object.keys(reportData) : 'null');
    console.log('reportData.pdf_download_url:', reportData?.pdf_download_url);
    console.log('pdfDownloadUrl prop:', pdfDownloadUrl);
    console.log('onDownloadPDF type:', typeof onDownloadPDF);

    // Parse reportData to extract PDF URL and other info - MUST match reportTypeMapping.js logic
    let parsedData = reportData;
    if (typeof reportData === 'string') {
        try {
            parsedData = JSON.parse(reportData);
        } catch (e) {
            console.error('Error parsing reportData in EHFUANOutputComponent:', e);
            parsedData = reportData;
        }
    }

    console.log('parsedData:', parsedData);
    console.log('parsedData.pdf_download_url:', parsedData?.pdf_download_url);

    // Extract PDF password hint from API response - check multiple locations
    const pdfPasswordHint = parsedData?.pdf_password_hint ||      // From saved report_json
                           reportData?.pdf_password_hint ||       // From direct API response
                           parsedData?.data?.pdf_password_hint || // In case it's nested in data
                           reportData?.data?.pdf_password_hint || // In case it's nested in data
                           null;
    console.log('UAN PDF Password Hint (DYNAMIC):', pdfPasswordHint);
    console.log('UAN Checked locations:', {
        'parsedData.pdf_password_hint': parsedData?.pdf_password_hint,
        'reportData.pdf_password_hint': reportData?.pdf_password_hint,
        'parsedData.data.pdf_password_hint': parsedData?.data?.pdf_password_hint,
        'reportData.data.pdf_password_hint': reportData?.data?.pdf_password_hint
    });

    const remainingBalance = parsedData?.data?.remaining_balance || parsedData?.remaining_balance;
    console.log('EHFUANOutputComponent - remaining balance:', remainingBalance);
    
    // Handle download functionality
    const handleDownloadPDF = async () => {
        console.log('=== UAN DOWNLOAD BUTTON CLICKED ===');
        console.log('=== UAN PDF DOWNLOAD DEBUG START ===');
        console.log('pdfDownloadUrl prop:', pdfDownloadUrl);
        console.log('reportData:', reportData);
        console.log('parsedData:', parsedData);
        console.log('parsedData.pdf_download_url:', parsedData?.pdf_download_url);
        console.log('typeof parsedData:', typeof parsedData);
        console.log('typeof reportData:', typeof reportData);

        // Show password hint in toast when downloading
        if (pdfPasswordHint) {
            toast.info(pdfPasswordHint, {
                position: "top-center",
                autoClose: 15000, // Show for 15 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
            console.log('Password hint toast shown:', pdfPasswordHint);
        } else {
            console.log('No password hint available');
        }

        if (onDownloadPDF && typeof onDownloadPDF === 'function') {
            console.log('Using onDownloadPDF prop function');
            // Add a small delay to ensure toast appears before window opens
            setTimeout(() => {
                const result = onDownloadPDF();
                console.log('onDownloadPDF result:', result);
            }, 100);
            return;
        }

        // Check for download_link in the reportData - checking all possible locations
        // PRIORITIZE: parsedData.pdf_download_url (this is where the mapping puts it)
        const downloadLink = parsedData?.pdf_download_url ||  // CHECK THIS FIRST - from parsed JSON
                           pdfDownloadUrl ||                   // From props (should also be parsedData.pdf_download_url)
                           parsedData?.pdf_url ||
                           parsedData?.download_link ||
                           parsedData?.download_url ||
                           reportData?.pdf_url ||
                           reportData?.pdf_download_url || 
                           reportData?.download_link || 
                           reportData?.download_url ||
                           reportData?.data?.pdf_url ||
                           reportData?.data?.pdf_download_url ||
                           reportData?.data?.download_link ||
                           reportData?.response?.pdf_download_url ||
                           reportData?.api_response?.pdf_download_url ||
                           reportData?.report_json?.pdf_download_url;
        
        console.log('Final downloadLink found:', downloadLink);
        console.log('Source of downloadLink:');
        if (parsedData?.pdf_download_url) console.log('- Found in parsedData.pdf_download_url');
        if (pdfDownloadUrl) console.log('- Found in pdfDownloadUrl prop');
        if (parsedData?.pdf_url) console.log('- Found in parsedData.pdf_url');
        console.log('=== UAN PDF DOWNLOAD DEBUG END ===');
        
        if (!downloadLink) {
            console.error('=== NO DOWNLOAD LINK FOUND ===');
            console.error('Checked paths:');
            console.error('- parsedData?.pdf_download_url:', parsedData?.pdf_download_url);
            console.error('- pdfDownloadUrl:', pdfDownloadUrl);
            console.error('- parsedData?.pdf_url:', parsedData?.pdf_url);
            toast.error('PDF download URL not available');
            return;
        }

        try {
            toast.info('Preparing PDF download...');
            
            // If it's a full URL, open it directly
            if (downloadLink.startsWith('http')) {
                window.open(downloadLink, '_blank');
                toast.success('Download started');
                return;
            }
            
            // Otherwise, use the API path
            const urlObj = new URL(downloadLink, window.location.origin);
            const apiPath = urlObj.pathname;

            const response = await axiosInstance.get(apiPath, {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `uan_employment_history_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            toast.success('PDF downloaded successfully');
        } catch (error) {
            console.error('Download error:', error);
            let errorMessage = 'Failed to download PDF';
            if (error.response?.status === 500) {
                errorMessage = 'Server error while generating PDF. Please try again.';
            } else if (error.response?.status === 404) {
                errorMessage = 'PDF not found. Please regenerate the report.';
            }
            toast.error(errorMessage);
        }
    };

    if (!reportData) {
        return (
            <div className="employment-history-empty-state">
                <div className="empty-state-card">
                    <div className="empty-state-icon-container">
                        <i className="pi pi-briefcase empty-state-icon"></i>
                    </div>
                    <h3 className="empty-state-title">No Employment History Available</h3>
                    <p className="empty-state-description">
                        Start a verification to view employment history details
                    </p>
                </div>
            </div>
        );
    }

    // Extract employment data from various possible response structures
    let employmentData = [];
    let statusInfo = null;
    let applicationId = null;
    let uanNumber = null;

    if (reportData.data?.response?.employment_data) {
        employmentData = reportData.data.response.employment_data;
        statusInfo = reportData.data.status;
        applicationId = reportData.data.applicationId;
        uanNumber = reportData.data.status?.input?.uan;
    } else if (reportData.employment_summary?.employment_data) {
        employmentData = reportData.employment_summary.employment_data;
        uanNumber = reportData.employment_summary.uan;
    }

    // Calculate employment statistics
    const totalEmployments = employmentData.length;
    const activeEmployments = employmentData.filter(emp => !emp.date_of_exit || emp.date_of_exit === '').length;
    const completedEmployments = employmentData.filter(emp => emp.date_of_exit && emp.date_of_exit !== '').length;
    
    // Get unique establishments
    const uniqueEstablishments = [...new Set(employmentData.map(emp => emp.establishment_name))].length;
    
    // Calculate total experience (matching backend PHP DateTime::diff logic)
    let totalMonths = 0;
    employmentData.forEach(emp => {
        if (emp.date_of_joining) {
            // Parse dates in DD/MM/YYYY format
            const [startDay, startMonth, startYear] = emp.date_of_joining.split('/').map(Number);
            const startDate = new Date(startYear, startMonth - 1, startDay);
            
            let endDate;
            if (emp.date_of_exit && emp.date_of_exit !== '') {
                const [endDay, endMonth, endYear] = emp.date_of_exit.split('/').map(Number);
                endDate = new Date(endYear, endMonth - 1, endDay);
            } else {
                endDate = new Date(); // Current date for active employment
            }
            
            // Calculate year and month difference
            let years = endDate.getFullYear() - startDate.getFullYear();
            let months = endDate.getMonth() - startDate.getMonth();
            
            // Adjust if the end day is before the start day
            if (endDate.getDate() < startDate.getDate()) {
                months--;
            }
            
            // Adjust for negative months
            if (months < 0) {
                years--;
                months += 12;
            }
            
            totalMonths += (years * 12) + months;
        }
    });
    const totalYears = Math.floor(totalMonths / 12);
    const remainingMonths = totalMonths % 12;
    const totalExperience = totalYears > 0 ? `${totalYears} Years ${remainingMonths} Months` : `${remainingMonths} Months`;
    
    // Calculate job gaps
    const calculateJobGaps = () => {
        // Parse date in DD/MM/YYYY format
        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const [day, month, year] = dateStr.split('/').map(Number);
            return new Date(year, month - 1, day);
        };
        
        const sortedJobs = [...employmentData].sort((a, b) => {
            const dateA = parseDate(a.date_of_joining) || new Date();
            const dateB = parseDate(b.date_of_joining) || new Date();
            return dateA - dateB;
        });
        
        const gaps = [];
        for (let i = 0; i < sortedJobs.length - 1; i++) {
            const currentJob = sortedJobs[i];
            const nextJob = sortedJobs[i + 1];
            
            if (currentJob.date_of_exit && currentJob.date_of_exit !== '' && nextJob.date_of_joining) {
                const exitDate = parseDate(currentJob.date_of_exit);
                const joinDate = parseDate(nextJob.date_of_joining);
                
                // Add 1 day to exit date (assuming exit date is inclusive)
                exitDate.setDate(exitDate.getDate() + 1);
                
                const gapInMs = joinDate - exitDate;
                const gapInDays = Math.floor(gapInMs / (1000 * 60 * 60 * 24));
                
                if (gapInDays > 0) {
                    // Calculate months and days more accurately
                    let years = 0;
                    let months = 0;
                    let days = gapInDays;
                    
                    // Calculate years
                    if (days >= 365) {
                        years = Math.floor(days / 365);
                        days = days % 365;
                    }
                    
                    // Calculate months (using average of 30.44 days per month)
                    if (days >= 30) {
                        months = Math.floor(days / 30.44);
                        days = Math.floor(days % 30.44);
                    }
                    
                    // Build description
                    let gapDescription = '';
                    if (years > 0) {
                        gapDescription += `${years} year${years > 1 ? 's' : ''} `;
                    }
                    if (months > 0) {
                        gapDescription += `${months} month${months > 1 ? 's' : ''} `;
                    }
                    if (days > 0 || (years === 0 && months === 0)) {
                        gapDescription += `${days} day${days !== 1 ? 's' : ''}`;
                    }
                    
                    gaps.push({
                        previousCompany: currentJob.establishment_name,
                        previousExitDate: currentJob.date_of_exit,
                        nextCompany: nextJob.establishment_name,
                        nextJoinDate: nextJob.date_of_joining,
                        gapDays: gapInDays,
                        gapYears: years,
                        gapMonths: months,
                        gapDaysRemainder: days,
                        gapDescription: gapDescription.trim()
                    });
                }
            }
        }
        return gaps;
    };
    
    const jobGaps = calculateJobGaps();

    // Status template for employment
    const statusBodyTemplate = (rowData) => {
        const isActive = !rowData.date_of_exit || rowData.date_of_exit === '';
        return (
            <Tag 
                severity={isActive ? 'success' : 'info'} 
                value={isActive ? 'Active' : 'Completed'}
                icon={isActive ? 'pi pi-check-circle' : 'pi pi-clock'}
                style={{
                    fontSize: '12px',
                    fontWeight: '700',
                    padding: '4px 8px'
                }}
            />
        );
    };

    // Duration template
    const durationTemplate = (rowData) => {
        if (!rowData.date_of_joining) return <span style={{fontSize: '14px', color: 'var(--surface-500)'}}>N/A</span>;
        
        const [startDay, startMonth, startYear] = rowData.date_of_joining.split('/').map(Number);
        const startDate = new Date(startYear, startMonth - 1, startDay);
        
        let endDate;
        if (rowData.date_of_exit && rowData.date_of_exit !== '') {
            const [endDay, endMonth, endYear] = rowData.date_of_exit.split('/').map(Number);
            endDate = new Date(endYear, endMonth - 1, endDay);
        } else {
            endDate = new Date();
        }
        
        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
        
        if (endDate.getDate() < startDate.getDate()) {
            months--;
        }
        
        if (months < 0) {
            years--;
            months += 12;
        }
        
        return <span style={{fontSize: '14px', fontWeight: '600', color: 'var(--text-color)'}}>{years}y {months}m</span>;
    };

    return (
        <div>
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
                <h2 className="text-lg font-semibold text-900 m-0">
                    <i className="pi pi-briefcase mr-2 text-primary" aria-hidden="true" />
                    Employment History by UAN Report
                </h2>
                {!shouldHideCredits && (
                    <Tag
                        severity="success"
                        icon="pi pi-wallet"
                        value={`Remaining: ${remainingBalance !== undefined ? remainingBalance : effectiveServiceInfo?.available_credits || 'N/A'}`}
                        className="text-sm"
                    />
                )}
            </div>


            {/* Modern Summary Stats Cards - Compact */}
            <div className="grid">
                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-briefcase text-2xl text-blue-500 mb-1"></i>
                        <div className="text-xl font-bold">{totalEmployments}</div>
                        <div className="text-xs text-500">Total Jobs</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-check-circle text-2xl text-green-500 mb-1"></i>
                        <div className="text-xl font-bold">{activeEmployments}</div>
                        <div className="text-xs text-500">Active</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-building text-2xl text-purple-500 mb-1"></i>
                        <div className="text-xl font-bold">{uniqueEstablishments}</div>
                        <div className="text-xs text-500">Companies</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-calendar text-2xl text-orange-500 mb-1"></i>
                        <div className="text-xl font-bold">{totalYears}y {remainingMonths}m</div>
                        <div className="text-xs text-500">Experience</div>
                    </Card>
                </div>

                <div className="col-12 md:col-6 lg:col">
                    <Card className="p-2 text-center">
                        <i className="pi pi-exclamation-triangle text-2xl text-yellow-500 mb-1"></i>
                        <div className="text-xl font-bold">{jobGaps.length}</div>
                        <div className="text-xs text-500">Job Gaps</div>
                    </Card>
                </div>
            </div>

            {/* Main Content Section */}
            <div className="content-section">
                {/* Employee Information Card - Modern Style */}
                {/* {employmentData.length > 0 && (
                    <div className="subsection">
                        <div className="section-header">
                            <h2 className="section-title">
                                Employee Information
                            </h2>
                            <div className="section-subtitle">
                                Personal and identification details
                            </div>
                        </div>
                        <div className="info-cards-grid">
                            <div className="info-card">
                                <div className="info-label">Employee Name</div>
                                <div className="info-value">{employmentData[0].name || 'N/A'}</div>
                            </div>
                            <div className="info-card">
                                <div className="info-label">Guardian Name</div>
                                <div className="info-value">{employmentData[0].guardian_name || 'N/A'}</div>
                            </div>
                            <div className="info-card">
                                <div className="info-label">UAN Number</div>
                                <div className="info-value">{employmentData[0].uan || uanNumber || 'N/A'}</div>
                            </div>
                            <div className="info-card">
                                <div className="info-label">Total Records</div>
                                <div className="info-value">{totalEmployments} Employments</div>
                            </div>
                        </div>
                    </div>
                )} */}

                {/* Employment History Details - Modern Style */}
                <div className="subsection">
                    {/* <div className="section-header">
                        <h2 className="section-title">
                            Employment History
                        </h2>
                        <div className="section-subtitle">
                            {(() => {
                                const gapCount = jobGaps.length;
                                if (gapCount > 0) {
                                    return `${totalEmployments} Records • ${gapCount} Gap${gapCount > 1 ? 's' : ''} Identified`;
                                }
                                return `${totalEmployments} Records`;
                            })()}
                        </div>
                    </div> */}
                        {employmentData.length > 0 ? (
                            <div className="employment-table-wrapper">
                                <DataTable 
                                    value={(() => {
                                        // Parse date helper function
                                        const parseDate = (dateStr) => {
                                            if (!dateStr) return null;
                                            const [day, month, year] = dateStr.split('/').map(Number);
                                            return new Date(year, month - 1, day);
                                        };
                                        
                                        // Sort employments by joining date (ascending - oldest first)
                                        const employmentsWithDates = [...employmentData]
                                            .filter(emp => emp.date_of_joining && emp.date_of_joining !== '')
                                            .sort((a, b) => {
                                                return parseDate(a.date_of_joining) - parseDate(b.date_of_joining);
                                            });
                                        
                                        const employmentsWithoutDates = [...employmentData]
                                            .filter(emp => !emp.date_of_joining || emp.date_of_joining === '');
                                        
                                        // Create timeline data with gaps
                                        const timelineData = [];
                                        
                                        // Process employments and detect gaps
                                        for (let i = 0; i < employmentsWithDates.length; i++) {
                                            const currentEmp = employmentsWithDates[i];
                                            
                                            // Add employment record
                                            timelineData.push({
                                                ...currentEmp,
                                                recordType: 'employment',
                                                recordIndex: i
                                            });
                                            
                                            // Check for gap BEFORE the next employment (if not the last one)
                                            if (i < employmentsWithDates.length - 1) {
                                                const nextEmp = employmentsWithDates[i + 1];
                                                
                                                // Only check gap if current job has exit date
                                                if (currentEmp.date_of_exit && currentEmp.date_of_exit !== '') {
                                                    const exitDate = parseDate(currentEmp.date_of_exit);
                                                    const nextJoinDate = parseDate(nextEmp.date_of_joining);
                                                    
                                                    // Calculate the actual gap - the day after exit to the day before joining
                                                    const dayAfterExit = new Date(exitDate);
                                                    dayAfterExit.setDate(dayAfterExit.getDate() + 1);
                                                    
                                                    // Calculate gap in milliseconds and days
                                                    const gapInMs = nextJoinDate - dayAfterExit;
                                                    const gapInDays = Math.ceil(gapInMs / (1000 * 60 * 60 * 24));
                                                    
                                                    // Add gap record only if there's an actual gap (more than 0 days between jobs)
                                                    if (gapInDays > 0) {
                                                        // Format dates for display
                                                        const formatDateForGap = (dateStr) => {
                                                            const [day, month, year] = dateStr.split('/').map(Number);
                                                            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                            return `${monthNames[month - 1]} ${year}`;
                                                        };
                                                        
                                                        // Calculate precise gap duration
                                                        const gapStartDate = dayAfterExit;
                                                        
                                                        // Calculate years, months, and days
                                                        let years = nextJoinDate.getFullYear() - gapStartDate.getFullYear();
                                                        let months = nextJoinDate.getMonth() - gapStartDate.getMonth();
                                                        let days = nextJoinDate.getDate() - gapStartDate.getDate();
                                                        
                                                        // Adjust for negative days
                                                        if (days < 0) {
                                                            months--;
                                                            const prevMonth = new Date(nextJoinDate.getFullYear(), nextJoinDate.getMonth(), 0);
                                                            days += prevMonth.getDate();
                                                        }
                                                        
                                                        // Adjust for negative months
                                                        if (months < 0) {
                                                            years--;
                                                            months += 12;
                                                        }
                                                        
                                                        let gapDuration = '';
                                                        if (years > 0) {
                                                            gapDuration = `${years}y `;
                                                        }
                                                        if (months > 0) {
                                                            gapDuration += `${months}m `;
                                                        }
                                                        if (days > 0 || (!years && !months)) {
                                                            gapDuration += `${days}d`;
                                                        }
                                                        
                                                        // Format full dates for display in Period column
                                                        const formatFullDate = (dateStr) => {
                                                            const [day, month, year] = dateStr.split('/').map(Number);
                                                            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                            return `${day} ${monthNames[month - 1]} ${year}`;
                                                        };
                                                        
                                                        // Calculate the actual gap period dates
                                                        const gapStartDateStr = (() => {
                                                            const [d, m, y] = currentEmp.date_of_exit.split('/').map(Number);
                                                            const exitDate = new Date(y, m - 1, d);
                                                            exitDate.setDate(exitDate.getDate() + 1); // Day after exit
                                                            const day = exitDate.getDate().toString().padStart(2, '0');
                                                            const month = (exitDate.getMonth() + 1).toString().padStart(2, '0');
                                                            const year = exitDate.getFullYear();
                                                            return `${day}/${month}/${year}`;
                                                        })();
                                                        
                                                        const gapEndDateStr = (() => {
                                                            const [d, m, y] = nextEmp.date_of_joining.split('/').map(Number);
                                                            const joinDate = new Date(y, m - 1, d);
                                                            joinDate.setDate(joinDate.getDate() - 1); // Day before joining
                                                            const day = joinDate.getDate().toString().padStart(2, '0');
                                                            const month = (joinDate.getMonth() + 1).toString().padStart(2, '0');
                                                            const year = joinDate.getFullYear();
                                                            return `${day}/${month}/${year}`;
                                                        })();
                                                        
                                                        timelineData.push({
                                                            recordType: 'gap',
                                                            establishment_name: 'Employment Gap',
                                                            gapDuration: gapDuration.trim(),
                                                            gapDays: gapInDays,
                                                            gapSeverity: gapInDays > 365 ? 'high' : gapInDays > 90 ? 'medium' : 'low',
                                                            startDate: formatDateForGap(currentEmp.date_of_exit),
                                                            endDate: formatDateForGap(nextEmp.date_of_joining),
                                                            gapStartFullDate: formatFullDate(gapStartDateStr),
                                                            gapEndFullDate: formatFullDate(gapEndDateStr),
                                                            afterCompany: currentEmp.establishment_name,
                                                            beforeCompany: nextEmp.establishment_name,
                                                            recordIndex: i + 0.5
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                        
                                        // Add employments without dates at the end
                                        employmentsWithoutDates.forEach((emp, index) => {
                                            timelineData.push({
                                                ...emp,
                                                recordType: 'employment',
                                                recordIndex: employmentsWithDates.length + index
                                            });
                                        });
                                        
                                        // Reverse to show most recent first (descending order)
                                        return timelineData.reverse();
                                    })()}
                                    paginator 
                                    rows={10}
                                    rowsPerPageOptions={[5, 10, 20]}
                                    responsiveLayout="stack"
                                    breakpoint="768px"
                                    className="modern-datatable"
                                    rowHover
                                    scrollable
                                    scrollHeight="flex"
                                >
                                    <Column 
                                        header="Company" 
                                        style={{minWidth: '200px'}}
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                return (
                                                    <div className="gap-indicator-cell">
                                                        <i className="pi pi-exclamation-triangle" style={{color: 'var(--orange-500)', marginRight: '4px'}}></i>
                                                        <span style={{fontWeight: '600', color: 'var(--orange-800)'}}>Employment Gap</span>
                                                    </div>
                                                );
                                            }
                                            
                                            return (
                                                <div className="company-name-cell">
                                                    <span style={{fontWeight: '600', color: 'var(--text-color)', display: 'block'}}>{rowData.establishment_name}</span>
                                                    <div style={{marginTop: '4px', display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                                                        {rowData.uan && (
                                                            <span style={{fontSize: '11px', color: 'var(--text-color-secondary)'}}>
                                                                <strong>UAN:</strong> {rowData.uan}
                                                            </span>
                                                        )}
                                                        {rowData.member_id && (
                                                            <span style={{fontSize: '11px', color: 'var(--text-color-secondary)'}}>
                                                                <strong>Member ID:</strong> {rowData.member_id}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    />
                                    <Column 
                                        header="Period"
                                        style={{minWidth: '150px'}}
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                const backgroundColor = 'var(--red-50)';
                                                const textColor = 'var(--red-800)';
                                                const borderColor = 'var(--red-200)';
                                                
                                                return (
                                                    <div style={{
                                                        backgroundColor: backgroundColor,
                                                        color: textColor,
                                                        padding: '6px 10px',
                                                        borderRadius: '6px',
                                                        border: `1px solid ${borderColor}`,
                                                        fontWeight: '500',
                                                        fontSize: '12px',
                                                        display: 'inline-block'
                                                    }}>
                                                        <i className="pi pi-exclamation-circle" style={{marginRight: '6px', fontSize: '12px'}}></i>
                                                        {rowData.gapStartFullDate || rowData.startDate} - {rowData.gapEndFullDate || rowData.endDate}
                                                    </div>
                                                );
                                            }
                                            
                                            const formatPeriodDate = (dateStr) => {
                                                if (!dateStr || dateStr === '') return null;
                                                
                                                try {
                                                    const parts = dateStr.split('/');
                                                    if (parts.length !== 3) return dateStr;
                                                    
                                                    const [day, month, year] = parts.map(Number);
                                                    if (isNaN(day) || isNaN(month) || isNaN(year)) return dateStr;
                                                    
                                                    const date = new Date(year, month - 1, day);
                                                    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                    return `${monthNames[date.getMonth()]} ${year}`;
                                                } catch (error) {
                                                    return dateStr;
                                                }
                                            };
                                            
                                            if (!rowData.date_of_joining) {
                                                return <span style={{color: 'var(--surface-500)', fontStyle: 'italic'}}>No dates available</span>;
                                            }
                                            
                                            const startDate = formatPeriodDate(rowData.date_of_joining);
                                            
                                            // Check if actively employed (no exit date OR exit date is in the future)
                                            let isActiveJob = false;
                                            if (!rowData.date_of_exit || rowData.date_of_exit === '' || rowData.date_of_exit === null) {
                                                isActiveJob = true;
                                            } else {
                                                const [day, month, year] = rowData.date_of_exit.split('/').map(Number);
                                                const exitDate = new Date(year, month - 1, day);
                                                const today = new Date();
                                                today.setHours(0, 0, 0, 0);
                                                isActiveJob = exitDate >= today;
                                            }
                                            
                                            const endDate = isActiveJob ? 'Present' : formatPeriodDate(rowData.date_of_exit);
                                            
                                            return (
                                                <span style={{
                                                    fontWeight: isActiveJob ? '600' : '400',
                                                    color: isActiveJob ? 'var(--green-600)' : 'var(--gray-700)'
                                                }}>
                                                    {startDate} - {endDate}
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column 
                                        header="Duration" 
                                        style={{minWidth: '100px'}}
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                const color = 'var(--red-800)';
                                                const bgColor = 'var(--red-50)';
                                                
                                                return (
                                                    <div style={{
                                                        backgroundColor: bgColor,
                                                        color: color,
                                                        padding: '4px 8px',
                                                        borderRadius: '4px',
                                                        fontWeight: '600',
                                                        fontSize: '13px',
                                                        display: 'inline-block'
                                                    }}>
                                                        <i className="pi pi-clock" style={{marginRight: '4px', fontSize: '11px'}}></i>
                                                        {rowData.gapDuration}
                                                    </div>
                                                );
                                            }
                                            
                                            return durationTemplate(rowData);
                                        }} 
                                    />
                                    <Column 
                                        header="Last PF Date" 
                                        style={{minWidth: '140px'}}
                                        className="hide-on-mobile"
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                return <span style={{color: 'var(--surface-500)'}}>-</span>;
                                            }
                                            
                                            const employeePFDate = rowData.last_pf_submitted;
                                            const employerPFDate = rowData.last_pf_submitted_by_employer;
                                            
                                            if (!employeePFDate && !employerPFDate) {
                                                return (
                                                    <div style={{color: 'var(--surface-500)', fontSize: '12px', textAlign: 'center'}}>
                                                        No Data
                                                    </div>
                                                );
                                            }
                                            
                                            // Format PF dates
                                            const formatPFDate = (dateStr) => {
                                                if (!dateStr) return null;
                                                try {
                                                    const [day, month, year] = dateStr.split('/');
                                                    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                                                    return `${day} ${monthNames[parseInt(month) - 1]} ${year}`;
                                                } catch {
                                                    return dateStr;
                                                }
                                            };
                                            
                                            return (
                                                <div style={{display: 'flex', flexDirection: 'column', gap: '3px'}}>
                                                    {employeePFDate && (
                                                        <div style={{fontSize: '11px'}}>
                                                            <span style={{color: 'var(--text-color-secondary)', fontWeight: '600'}}>Employee:</span>
                                                            <span style={{color: 'var(--green-600)', marginLeft: '4px'}}>{formatPFDate(employeePFDate)}</span>
                                                        </div>
                                                    )}
                                                    {employerPFDate && (
                                                        <div style={{fontSize: '11px'}}>
                                                            <span style={{color: 'var(--text-color-secondary)', fontWeight: '600'}}>Employer:</span>
                                                            <span style={{color: 'var(--cyan-600)', marginLeft: '4px'}}>{formatPFDate(employerPFDate)}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />
                                    <Column 
                                        header="Joining Date" 
                                        style={{minWidth: '120px'}}
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                return <span style={{color: 'var(--surface-500)'}}>-</span>;
                                            }
                                            
                                            if (!rowData.date_of_joining) {
                                                return <span style={{color: 'var(--surface-500)', fontStyle: 'italic'}}>N/A</span>;
                                            }
                                            
                                            return (
                                                <span style={{
                                                    fontSize: '13px',
                                                    fontWeight: '700',
                                                    color: 'var(--green-600)'
                                                }}>
                                                    <i className="pi pi-calendar-plus" style={{marginRight: '4px', fontSize: '11px'}}></i>
                                                    {rowData.date_of_joining}
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column 
                                        header="Exit Date" 
                                        style={{minWidth: '120px'}}
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                return <span style={{color: 'var(--surface-500)'}}>-</span>;
                                            }
                                            
                                            if (!rowData.date_of_exit || rowData.date_of_exit === '') {
                                                return (
                                                    <span style={{
                                                        fontSize: '13px',
                                                        fontWeight: '700',
                                                        color: 'var(--green-600)'
                                                    }}>
                                                        <i className="pi pi-briefcase" style={{marginRight: '4px', fontSize: '11px'}}></i>
                                                        Present
                                                    </span>
                                                );
                                            }
                                            
                                            return (
                                                <span style={{
                                                    fontSize: '13px',
                                                    fontWeight: '700',
                                                    color: 'var(--gray-500)'
                                                }}>
                                                    <i className="pi pi-calendar-minus" style={{marginRight: '4px', fontSize: '11px'}}></i>
                                                    {rowData.date_of_exit}
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column 
                                        header="Status" 
                                        style={{minWidth: '140px'}}
                                        body={(rowData) => {
                                            if (rowData.recordType === 'gap') {
                                                return (
                                                    <Tag 
                                                        severity="warning" 
                                                        value="GAP"
                                                        style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            padding: '2px 6px'
                                                        }}
                                                    />
                                                );
                                            }
                                            
                                            // Check if there's no date data
                                            if (!rowData.date_of_joining) {
                                                return (
                                                    <Tag 
                                                        severity="secondary" 
                                                        value="NO DATA"
                                                        style={{
                                                            fontSize: '11px',
                                                            fontWeight: '600',
                                                            padding: '2px 6px',
                                                            backgroundColor: 'var(--surface-200)',
                                                            color: 'var(--text-color-secondary)'
                                                        }}
                                                    />
                                                );
                                            }
                                            
                                            // Check if actively employed
                                            let isActive = false;
                                            let exitDateFormatted = '';
                                            
                                            if (!rowData.date_of_exit || rowData.date_of_exit === '' || rowData.date_of_exit === null) {
                                                // No exit date means currently working
                                                isActive = true;
                                            } else {
                                                // Has an exit date - check if it's in the past
                                                try {
                                                    const dateParts = rowData.date_of_exit.split('/');
                                                    const day = parseInt(dateParts[0], 10);
                                                    const month = parseInt(dateParts[1], 10) - 1; // JavaScript months are 0-based
                                                    const year = parseInt(dateParts[2], 10);
                                                    
                                                    const exitDate = new Date(year, month, day, 0, 0, 0, 0);
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);
                                                    
                                                    // Format the exit date for display
                                                    exitDateFormatted = rowData.date_of_exit;
                                                    
                                                    // Consider active if exit date is in the future or within last 90 days
                                                    const ninetyDaysAgo = new Date(today);
                                                    ninetyDaysAgo.setDate(today.getDate() - 90);
                                                    
                                                    isActive = exitDate > today || 
                                                              (exitDate >= ninetyDaysAgo && exitDate <= today);
                                                } catch (error) {
                                                    console.error('Error parsing date:', rowData.date_of_exit, error);
                                                    isActive = false;
                                                    exitDateFormatted = rowData.date_of_exit;
                                                }
                                            }
                                            
                                            // For completed status, show with date
                                            if (!isActive && exitDateFormatted) {
                                                return (
                                                    <div style={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
                                                        <Tag 
                                                            severity="info" 
                                                            value="COMPLETED"
                                                            icon="pi pi-clock"
                                                            style={{
                                                                fontSize: '11px',
                                                                fontWeight: '600',
                                                                padding: '4px 8px'
                                                            }}
                                                        />
                                                        <span style={{
                                                            fontSize: '10px',
                                                            color: 'var(--gray-500)',
                                                            marginLeft: '2px',
                                                            fontWeight: '500'
                                                        }}>
                                                            on {exitDateFormatted}
                                                        </span>
                                                    </div>
                                                );
                                            }
                                            
                                            return (
                                                <Tag 
                                                    severity={isActive ? 'success' : 'info'} 
                                                    value={isActive ? 'ACTIVE' : 'COMPLETED'}
                                                    icon={isActive ? 'pi pi-check-circle' : 'pi pi-clock'}
                                                    style={{
                                                        fontSize: '11px',
                                                        fontWeight: '600',
                                                        padding: '4px 8px'
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </DataTable>
                            </div>
                        ) : (
                            <div className="no-data-message">
                                <i className="pi pi-info-circle pr-2"></i>
                                <span>No employment records found</span>
                            </div>
                        )}
                </div>


            </div>

            {/* Download PDF Section - matching Driving Licence style */}
            <div className="mt-3" style={{ textAlign: 'center' }}>
                <Button
                    label="Download Employment History by UAN Report"
                    icon="pi pi-download"
                    onClick={handleDownloadPDF}
                    className="p-button-sm p-button-primary"
                    style={{
                        fontSize: '0.875rem',
                        padding: '0.5rem 1rem'
                    }}
                />

                {/* PDF Password Hint - positioned directly below download button */}
                {pdfPasswordHint && (
                    <div className="mt-2" style={{ textAlign: 'center' }}>
                        <Message
                            severity="info"
                            text={pdfPasswordHint}
                            style={{
                                fontSize: '0.875rem',
                                maxWidth: '1000px',
                                margin: '0 auto',
                                display: 'inline-block',
                                whiteSpace: 'nowrap'
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default EHFUANOutputComponent;